import React, { useCallback, useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { CircularProgress, Grid, Typography } from "@mui/material";

const ForemanHoursDetail = ({ data }) => {
  const [items, setItems] = useState([]);

  const columns = [
    {
      name: "HRS",
      label: " ",
    },
    {
      name: "L0",
      label: "L0",
    },
    {
      name: "W0",
      label: "W0",
    },
    {
      name: "D1",
      label: "D1",
    },
    {
      name: "W1",
      label: "W1",
    },
    {
      name: "D2",
      label: "D2",
    },
    {
      name: "W2",
      label: "W2",
    },
    {
      name: "D3",
      label: "D3",
    },
    {
      name: "W3",
      label: "W3",
    },
    {
      name: "D4",
      label: "D4",
    },
    {
      name: "W4",
      label: "W4",
    },
    {
      name: "D5",
      label: "D5",
    },
    {
      name: "W5",
      label: "W5",
    },
    {
      name: "RF",
      label: "RF",
    },
    {
      name: "BO",
      label: "BO",
    },
    {
      name: "ET_W",
      label: "ET/W",
    },
    {
      name: "ED",
      label: "ED",
    },
    {
      name: "IT",
      label: "IT",
    },
    {
      name: "EWO",
      label: "EWO",
    },
    {
      name: "TOTAL",
      label: "TOTAL",
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
    pagination: false,
    rowsPerPage: items.length,
  };

  const retreiveHoursData = useCallback((rowData) => {
    const phases = [
      "L0",
      "W0",
      "D1",
      "W1",
      "D2",
      "W2",
      "D3",
      "W3",
      "D4",
      "W4",
      "D5",
      "W5",
      "RF",
      "BO",
      "ET_W",
      "ED",
      "IT",
      "EWO",
    ];
    const estHrs = phases.reduce((acc, item, index) => {
      acc[item] = rowData[`PHASE${index + 1}_LABOR_HRS_EST`].toFixed(2);

      return acc;
    }, {});
    const actHrs = phases.reduce((acc, item, index) => {
      acc[item] = rowData[`PHASE${index + 1}_LABOR_HRS_ACT`].toFixed(2);

      return acc;
    }, {});
    const diffHrs = phases.reduce((acc, item, index) => {
      acc[item] = (
        rowData[`PHASE${index + 1}_LABOR_HRS_EST`] -
        rowData[`PHASE${index + 1}_LABOR_HRS_ACT`]
      ).toFixed(2);

      return acc;
    }, {});

    let newItems = {
      HRS_EST: {
        HRS: "EST HRS",
        ...estHrs,
        TOTAL: Object.values(estHrs)
          .reduce((total, value) => total + parseFloat(value), 0)
          .toFixed(2),
      },
      HRS_ACT: {
        HRS: "ACT HRS",
        ...actHrs,
        TOTAL: Object.values(actHrs)
          .reduce((total, value) => total + parseFloat(value), 0)
          .toFixed(2),
      },
      HRS_DIFF: {
        HRS: "DIFF HRS",
        ...diffHrs,
        TOTAL: Object.values(diffHrs)
          .reduce((total, value) => total + parseFloat(value), 0)
          .toFixed(2),
      },
    };
    const newItemsArray = [
      newItems["HRS_EST"],
      newItems["HRS_ACT"],
      newItems["HRS_DIFF"],
    ];
    console.log(newItemsArray);

    setItems(newItemsArray);
  }, []);

  useEffect(() => {
    retreiveHoursData(data);
  }, [data, retreiveHoursData]);

  return (
    <Grid container spacing={4}>
      <Grid item xs={12}>
        <MUIDataTable
          title={
            <Grid container alignItems="center" spacing={2}>
              <Grid item>
                <Typography variant="h5"></Typography>
              </Grid>
            </Grid>
          }
          data={items}
          columns={columns}
          options={options}
        />
      </Grid>
    </Grid>
  );
};

export default ForemanHoursDetail;
